<form id="wrapupForm" novalidate [formGroup]="lobbyWrapUpForm">
  <kendo-dialog id="wrapupDialog"
    [title]="isImpersonateAssist ? ('_Lobby_Wrap_Up_Impersonation_Text_' | translate) + ' ' + impersonateByName : ('_Lobby_Wrap_Up_Text_' | translate) + ' ' + lobbyEntryDetail.firstName + ' ' + lobbyEntryDetail.lastName"
    *ngIf="dialogOpened && lobbyEntryDetail"
    (close)="close()"
  >
    <kendo-dialog-messages closeTitle="{{'_General_Button_Close_Text_' | translate }}"></kendo-dialog-messages>
    <div class="lobby-wrap-up-popup-wrapper">
      <div class="scrollable-content">
        <div class="row">
          <!-- Now Assisting -->
          <div class="col-md-3 d-flex justify-content-between flex-column">
            <!--Title Panel-->
            <div>
              <div *ngIf="isImpersonateAssist" class="visitor-name-panel d-flex">
                <label >{{'_General_Visitor Name_Text_' | translate }}:</label>
                <span id="visitorName"  class="visitor-area">
                  {{ lobbyEntryDetail.firstName }} {{ lobbyEntryDetail.lastName }}
                </span>              
              </div>
              <div class="now-assisting-header">
                <div #container class="lobby-id-area d-flex align-items-center">
                  <label>{{'_Lobby_Wrap_Up_Lobby_ID_Text_' | translate }}</label>
                  <span class="lobby-id">{{ lobbyEntryDetail.lobbyEntryId }}</span>
                  <button id="copyLobbyId"
                    class="cc-icon-btn"
                    title="{{'_Lobby_Copy_Lobby_ID_Text_' | translate }}"
                    ngxClipboard
                    [cbContent]="lobbyEntryDetail.lobbyEntryId.toString()"
                    [container]="container"
                  >
                    <span class="far fa-copy" (click)="copyInputMessage()"></span>
                  </button>
                </div>
              </div>
            
              <!--Location and Name Panel-->
              <div class="location-name-panel d-flex align-items-center">
                <label *ngIf="signInLocationId !== lobbyEntryDetail.locationId">{{'_Lobby_Wrap_Up_Check_In_Location_Text_' | translate }}</label>
                <span id="locationName" *ngIf="signInLocationId !== lobbyEntryDetail.locationId" class="location-area">
                {{ lobbyEntryDetail.checkInLocation }}
                </span>
                <!-- <div>
                  <span
                    class="name-area"
                    title="{{ lobbyEntryDetail.firstName }} {{
                      lobbyEntryDetail.lastName
                    }}"
                  >
                    {{ lobbyEntryDetail.firstName }} {{ lobbyEntryDetail.lastName }}
                  </span>
                </div> -->
              </div>
    
              <!-- Account Number -->
              <div
                class="input" id="accountNumberDisplay"
                *ngIf="lobbyWrapUpConfiguration && lobbyWrapUpConfiguration.EnableAccountNumber">
                <label for="accountNumber">{{'_Account_Number_Field_Text_' | translate}}</label>
                <input
                  id="accountNumber"
                  class="form-control"
                  type="text"
                  maxlength="50"
                  readonly="readonly"
                  value="{{ lobbyEntryDetail.accountNumber }}"/>
                <div class="cc-validation">
                  <div></div>
                </div>
              </div>
    
              <!-- Requests -->
              <div class="input cc-textarea">
                <label class="d-flex mb-1" for="requests">{{'_General_Reasons_To_Visit_Text_' | translate }}              
                  <!-- <span *ngIf="isCheckListAvailableForRequestedService" (click)="viewCheckListForRequestedService()">
                    <img class="checklist-icon d-flex" src="assets/images/icon/checklist-icon.svg" />
                  </span> -->
                </label>
                <div class="requests-chips chip-section">
                  <div
                    class="chip"
                    *ngFor="let request of lobbyEntryDetail.requestedServices; let i = index"
                  >
                    <!-- <kendo-chip id="{{ 'request' + i}}" label="{{ request.name }}"> 
                    </kendo-chip> -->
                    <div class="checklist-chip-container">
                      <label for="">{{request.name}}</label>
                      <span (click)="
                      provideService(
                        request.id,
                        request.isCheckListAvailable
                      )
                    " *ngIf="request.isCheckListAvailable"><img class="checklist-icon" src="assets/images/icon/checklist-icon.svg" alt=""/></span>
                    </div>
                  </div>
                </div>
              </div>  
              <!-- Notes -->
              <div class="input">
                <label for="notes">{{'_General_Notes_Text_' | translate }}  </label>
                <textarea
                  id="notes"
                  class="form-control"
                  type="text"
                  readonly="readonly"
                  value="{{ lobbyEntryDetail.notes }}"
                  rows="3"></textarea>
                <div class="cc-validation">
                  <div></div>
                </div>
              </div>
            </div>

              <!-- Current Interaction Time -->
              <div class="interaction-time">
                {{'_Lobby_Wrap_Up_Current_Interaction_Time_Text_' | translate }}
                <app-app-timer  [autoStart]="true" [startTime]="lobbyEntryDetail.currentInteractionTime" format="hms"></app-app-timer>
              </div>

          </div>

          <!-- Services -->
          <div class="col-md-5 wrap-up-services">
            <!-- Select Services -->
            <div class="select-services">
              <div class="row">
                <div class="col-md-6">
                  <h6 class="sub-heading">{{'_Lobby_Wrap_Up_Select_Request_Text_' | translate }}</h6>
                </div>
                <div class="col-md-6 select-services-actions">
                  <div>
                    <button class="cc-icon-btn">
                      <img class="sort-icon" *ngIf="sortdedAscending" src="assets/images/icon/sort-alpha-up-solid.svg" alt="" (click)="sortServices()"/>
                      <img class="sort-icon"  *ngIf="!sortdedAscending" src="assets/images/icon/sort-alpha-down-solid.svg" alt="" (click)="sortServices()"/>                   
                    </button>
                  </div>
                  <div class="cc-popup-search">
                    <input
                      id="kioskConfigSearchText"
                      class="form-control"
                      type="text"
                      placeholder="{{'_General_Search_Text_' | translate }}"
                      [(ngModel)]="searchFilter"
                      [ngModelOptions]="{ standalone: true }"
                      (ngModelChange)="serviceFilterChanged($event)"
                      (keypress)="serviceFilterKeyPress($event)"
                    />
                    <button id="clearSearch"
                      [ngClass]="{ 'show-btn': searchFilter !== '' }"
                      class="cc-close-btn"
                      (click)="clearSearchFilter()"
                    >
                      <span class="fas fa-times"></span>
                    </button>
                    <button
                      id="kioskConfigSearchButton"
                      type="button"
                      class="cc-search-btn"
                      (click)="setSearchFilter()"
                    >
                      <span class="fas fa-search"> </span>
                    </button>
                  </div>
                </div>
              </div>

              <!-- Temporary services list (to be decided and styled once with or without category condition is implemented  -->
              <div class="psPanel mt-3">
                <!--  Without Category -->
                <div id="doNotDisplayCategories"
                  class="ps-list"
                  *ngIf="lobbyWrapUpConfiguration && !lobbyWrapUpConfiguration.ShowCategoriesInLobby"
                >
                  <ul>
                    <li *ngFor="let service of lobbyServices; let i = index">
                      <button id= "{{'serviceProvided' + i}}"
                        (click)="
                          provideService(
                            service.service.id,
                            service.service.isCheckListAvailable
                          )
                        "
                        class="cc-icon-btn d-flex"
                      >
                        {{ service.service.name }}
                        <span
                          *ngIf="service.service.isCheckListAvailable"
                        ><img class="checklist-icon d-flex" src="assets/images/icon/checklist-icon.svg" alt=""/></span>
                      </button>
                    </li>
                  </ul>
                </div>

                <!-- With Category -->
                <div
                  class="ps-list-with-category"
                  *ngIf="lobbyWrapUpConfiguration && lobbyWrapUpConfiguration.ShowCategoriesInLobby"
                >
                  <ngb-accordion
                    [closeOthers]="false"
                    class="cc-accordion category-list"
                  >
                    <ngb-panel
                      id="{{ serviceWithCategory.catName }}"
                      title=""
                      *ngFor="
                        let serviceWithCategory of lobbyServices"
                    >
                      <ng-template ngbPanelTitle>
                        <span>{{ serviceWithCategory.catName }}</span>
                        <span class="caret"></span>
                      </ng-template>
                      <ng-template ngbPanelContent>
                        <div class="ps-list">
                          <ul>
                            <li *ngFor="let service of serviceWithCategory.service; let i = index">
                              <button id= "{{'serviceProvided' + i}}"
                                (click)="
                                  provideService(
                                    service.service.id,
                                    service.service.isCheckListAvailable
                                  )
                                "
                                class="cc-icon-btn d-flex"
                              >
                                {{ service.service.name }}
                                <span
                                  *ngIf="service.service.isCheckListAvailable"
                                ><img class="checklist-icon d-flex" src="assets/images/icon/checklist-icon.svg" alt="" /></span>
                              </button>
                            </li>
                          </ul>
                        </div>
                      </ng-template>
                    </ngb-panel>
                  </ngb-accordion>
                </div>
              </div>
            </div>
          </div>

          <!-- Completed Activities -->
          <div class="col-md-4">
            <!--Title-->
            <h6 class="sub-heading">{{'_Lobby_Wrap_Up_Completed_Request_Text_' | translate }}</h6>

            <div class="completed-activities-list-section">
              <!-- Upon clicking Instant assist button or Assist icon-->

              <div
                class="completed-activities-list"
                *ngIf="lobbyEntryDetail.lobbyInteractions.length === 1"
              >
                <ul>
                  <li
                    *ngFor="
                      let service of currentInteraction!.lobbyServiceProvided;
                      let i = index;
                      trackBy: trackByFn
                    "
                  >
                    <div class="completed-activities-item">
                      <span class="completed-activities-item-name">
                        {{ service.serviceName }}
                      </span>
                      <div class="completed-activities-item-actions">
                        <div
                          class="
                            completed-activities-item-time-stamp
                            d-flex
                            align-items-center
                          "
                        >
                        <button id="{{'addReferenceNoBtn' + i}}"
                        title="{{'_General_Add_Reference_Number_Text_' | translate }}"
                        class="cc-icon-btn"
                        (click)="currentlyEditingReference == null &&
                          showEditReference(
                            currentInteraction!.interactionId,
                            service.serviceProvidedId
                          )
                        "
                        [disabled]="(currentlyEditingReference == null ? service.refferenceNumber : null) || (currentlyEditingReference && currentlyEditingReference != service.serviceProvidedId)"
                        [ngClass]="{
                          'cc-icon-btn-disabled': (currentlyEditingReference == null ? service.refferenceNumber : null) || (currentlyEditingReference && currentlyEditingReference != service.serviceProvidedId)
                        }"
                        *ngIf="lobbyWrapUpConfiguration && lobbyWrapUpConfiguration.EnableReferenceNumber">
                        #
                      </button>
                      <span
                      class="ref-num"
                      *ngIf="
                        !service.showEditReference &&
                        service.refferenceNumber
                      "
                      >: {{ service.refferenceNumber }}</span
                    >
                          <div class="ref-num-time">{{ service.servicTime * 1000 | date: "HH:mm:ss":"UTC" }}</div>
                        </div>
                        <button id="{{'removeProvidedService' + i}}"
                          class="cc-icon-btn"
                          (click)="
                            removeProvidedService(service.serviceProvidedId)
                          "
                        >
                          <span class="fas fa-trash-alt"></span>
                        </button>
                      </div>
                    </div>
                    <div
                            class="
                              ref-num-container
                              d-flex
                              align-items-center
                              flex-row
                              justify-content-end
                            "
                            *ngIf="lobbyWrapUpConfiguration && lobbyWrapUpConfiguration.EnableReferenceNumber"
                          >
                            <input
                              id="reference{{ service.serviceProvidedId }}"
                              *ngIf="service.showEditReference"
                              maxlength="50"
                              class="form-control"
                              placeholder="{{'_General_Add_Reference_Number_Text_' | translate }}"
                              [ngModel]="service.refferenceNumber"
                              [ngModelOptions]="{ standalone: true }"
                              (input)="
                                setReference(
                                  currentInteraction!.interactionId,
                                  service.serviceProvidedId,
                                  $event.target
                                )
                              "
                              (keypress)="restrictSpecialCharacters($event)"
                              (paste)="restrictPasteSpecialCharacters($event)"
                            />
                            <button
                              *ngIf="service.showEditReference"
                              id="{{'addServiceReference' + i}}"
                              type="button"
                              class="cc-icon-btn"
                              (click)="
                                updateProvidedServiceReference(
                                  service.serviceProvidedId,
                                  service.refferenceNumber
                                )
                              "
                            >
                              <span class="fas fa-save" title="{{'_General_Button_Save_Text_' | translate }}"> </span>
                            </button>

                            <button
                              *ngIf="service.showEditReference"
                              id="{{ 'cancelServiceReference' + i}}"
                              type="button"
                              class="cc-icon-btn"
                              (click)="
                              closeEditReference(
                                  currentInteraction!.interactionId,
                                  service.serviceProvidedId
                                )
                              "
                            >
                              <span class="fas fa-times" title="{{'_General_Button_Cancel_Text_' | translate }}"> </span>
                            </button>
                          </div>
                  </li>
                </ul>
              </div>

              <!-- Upon clicking Instant assist button or Assist icon ends here-->

              <!-- Upon opening wrap up after record being added to the lobby-->
              <div
                class="completed-activities-list after-recorded"
                *ngIf="lobbyEntryDetail.lobbyInteractions.length > 1"
              >
                <!--Previous Interactions-->
                <div
                  class="previous-interactions"
                  *ngIf="previousInteractions!.length > 0"
                >
                  <!-- This batch will repeat inside previous interactions div as multiple interactions happen-->
                  <div
                    class="interaction-batches"
                    *ngFor="let interation of previousInteractions; let i = index"
                  >
                    <ul>
                      <li class="list-title">
                        <span class="interaction-name"
                          >{{'_Lobby_Wrap_Up_Interaction_Text_' | translate }} {{ i + 1 }}</span
                        >
                        <span
                          >{{'_General_Assisted_By_Sub_Text_' | translate }} {{ interation.assistedBy.firstName }}
                          {{ interation.assistedBy.lastName }}</span
                        >
                      </li>
                      <li
                        class="list-subtitle"
                        *ngIf="interation.lobbyServiceProvided.length === 0"
                      >
                        <span>{{'_Lobby_Wrap_Up_No_Products_Services_Provided_Text_' | translate }}</span>
                        <span class="sub-timer">{{
                          getInteractionDuration(interation) * 1000
                            | date: "HH:mm:ss":"UTC"
                        }}</span>
                      </li>
                      <div *ngIf="interation.lobbyServiceProvided.length > 0">
                        <li
                          *ngFor="let service of interation.lobbyServiceProvided; let i=index">
                          <div class="completed-activities-item">
                            <span class="completed-activities-item-name">
                              {{ service.serviceName }}
                            </span>
                            <div class="completed-activities-item-actions">
                              <div class="completed-activities-item-time-stamp">
                                <button id="{{'serviceProvidedRef' + i}}"
                                  class="cc-icon-btn"
                                  [disabled]="service.refferenceNumber"
                                  [ngClass]="'cc-icon-btn-disabled'"
                                  *ngIf="lobbyWrapUpConfiguration.EnableReferenceNumber"
                                >
                                  #
                                </button>
                                <span
                                  class="ref-num"
                                  *ngIf="
                                    !service.showEditReference &&
                                    service.refferenceNumber
                                  "
                                  >: {{ service.refferenceNumber }}</span
                                >
                                <div class="ref-num-time">
                                  {{
                                    service.servicTime * 1000 | date: "HH:mm:ss":"UTC"
                                  }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </div>
                    </ul>
                  </div>
                </div>

                <!--Current Interaction-->
                <hr>
                <div>
                  <span class="interaction-name outside-list"
                    >{{'_Lobby_Wrap_Up_Current_Interaction_Text_' | translate }}</span
                  >
                  <div class="current-interaction">
                    <ul>
                      <li
                        *ngFor="
                          let service of currentInteraction!.lobbyServiceProvided;
                          let i = index;
                          trackBy: trackByFn
                        "
                      >
                        <div class="completed-activities-item">
                          <span class="completed-activities-item-name">
                            {{ service.serviceName }}
                          </span>
                          <div class="completed-activities-item-actions">
                            <div
                              class="
                                completed-activities-item-time-stamp
                                d-flex
                                align-items-center
                              "
                            >
                            <button
                            title="{{'_General_Add_Reference_Number_Text_' | translate }}"
                            class="cc-icon-btn"
                            (click)="currentlyEditingReference == null && 
                              showEditReference(
                                currentInteraction!.interactionId,
                                service.serviceProvidedId
                              )
                            "
                            [disabled]="(currentlyEditingReference == null ? service.refferenceNumber : null) || (currentlyEditingReference && currentlyEditingReference != service.serviceProvidedId)"
                            [ngClass]="{
                              'cc-icon-btn-disabled':
                              (currentlyEditingReference == null ? service.refferenceNumber : null) || (currentlyEditingReference && currentlyEditingReference != service.serviceProvidedId)
                            }"
                            *ngIf="lobbyWrapUpConfiguration.EnableReferenceNumber"
                          >
                            #
                          </button>
                          <span
                          class="ref-num"
                          *ngIf="
                            !service.showEditReference &&
                            service.refferenceNumber
                          "
                          >: {{ service.refferenceNumber }}</span>
                              <div class="ref-num-time">
                                {{
                                  service.servicTime * 1000 | date: "HH:mm:ss":"UTC"
                                }}
                              </div>
                            </div>
                            <button
                              class="cc-icon-btn"
                              (click)="
                                removeProvidedService(service.serviceProvidedId)
                              "
                            >
                              <span
                                class="fas fa-trash-alt"
                                title="{{'_General_Button_Delete_Text_' | translate }}"
                              ></span>
                            </button>
                          </div>
                        </div>
                        <div
                        class="
                          ref-num-container
                          d-flex
                          align-items-center
                          flex-row
                          justify-content-end
                        "
                        *ngIf="
                        lobbyWrapUpConfiguration && lobbyWrapUpConfiguration.EnableReferenceNumber">
                        <input
                          id="reference{{ service.serviceProvidedId }}"
                          *ngIf="service.showEditReference"
                          maxlength="50"
                          class="form-control"
                          placeholder="{{'_General_Add_Reference_Number_Text_' | translate }}"
                          [ngModel]="service.refferenceNumber"
                          [ngModelOptions]="{ standalone: true }"
                          (input)="
                            setReference(
                              currentInteraction!.interactionId,
                              service.serviceProvidedId,
                              $event.target
                            )
                          "
                        />
                        <button
                          *ngIf="service.showEditReference"
                          id="addServiceReference"
                          type="button"
                          class="cc-icon-btn"
                          (click)="
                            updateProvidedServiceReference(
                              service.serviceProvidedId,
                              service.refferenceNumber
                            )
                          "
                        >
                          <span class="fas fa-save" title="{{'_General_Button_Save_Text_' | translate }}"> </span>
                        </button>

                        <button
                          *ngIf="service.showEditReference"
                          id="cancelServiceReference"
                          type="button"
                          class="cc-icon-btn"
                          (click)="
                          closeEditReference(
                              currentInteraction!.interactionId,
                              service.serviceProvidedId
                            )
                          "
                        >
                          <span class="fas fa-times" title="{{'_General_Button_Cancel_Text_' | translate }}"> </span>
                        </button>
                      </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <!-- Upon opening wrap up after record being added to the lobby ends here-->

              <!-- Comment -->
              <div class="input cc-textarea comments">
                <label for="comments"
                  >{{'_Lobby_Wrap_Up_Comment_Text_' | translate }}<span *ngIf="lobbyWrapUpConfiguration.CommentsRequired" tabindex="-1" class="required-field">*</span></label
                >
                <!-- <span tabindex="-1" class="required-field">*</span> -->
                <textarea
                  id="comments"
                  maxlength="250"
                  class="form-control"
                  rows="4"
                  formControlName="wrapUpCommentFormControl"
                  [ngModel]="wrapUpComment"
                  (ngModelChange)="updateWrapUpText($event)"
                  (blur)="blur()"
                  (keypress)="validateSpecialCharacters($event)"
                  input-field-on-past-filter
                ></textarea>
              
                <div class="cc-validation">
                  <div *ngIf="lobbyWrapUpConfiguration.CommentsRequired && displayMessage.wrapUpCommentFormControl">
                    {{displayMessage.wrapUpCommentFormControl}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Wrap-up Button Panel -->
      <div class="wrap-up-btn-panel">
        <div class="action-btn">
          <div>
            <button class="btn btn-primary" id="return-visitor-button" [disabled]="previousInteractions!.length === 4 || lobbyWrapUpForm.invalid"
              (click)="returnVisitorToLobby()"> {{'_Lobby_Wrap_Up_Return_Visitor_Text_' | translate }} </button>
            <button  *ngIf="(isACLicenseEnabled$ | async) && isAllowWidgetAppointmentsThroughPortalEnabled" class="btn btn-primary" id="book-followup-btn" (click)="goToACWebWidgetFollowUp()"> {{'_Lobby_Wrap_Up_Book_Follow_Up_Appointment_Text_' | translate }} </button>
          </div>
          <div>
            <button class="btn btn-secondary" (click)="close()" id="close-wrapup-btn">{{'_General_Button_Close_Text_' | translate }} </button>
            <button class="btn btn-primary" id="confirm-wrapup-btn"
              [disabled]="currentInteraction!.lobbyServiceProvided.length === 0 || lobbyWrapUpForm.invalid"
              (click)="wrapUpAssist()">{{'_General_WrapUp_Text_' | translate }} </button>
          </div>
        </div>
      </div>
    </div>
  </kendo-dialog>
</form>

<kendo-dialog
  id="checkListDialogModel"
  title="{{'_Checklist_Header_Text_' | translate }} {{ checkListPopUpDetail!.serviceDetail.name }}"
  *ngIf="checkListPopUpDetail!.showCheckList"
  (close)="cancelCheckListDialog()"
  [minWidth]="250"
  [width]="500"
>
  <kendo-dialog-messages closeTitle="{{'_General_Button_Close_Text_' | translate }}"></kendo-dialog-messages>
  <div class="psPanel px-2">
    <div class="ps-list">
      <ul>
        <li
          class="wrap-checklist-item checkbox"
          *ngFor="let item of checkListPopUpDetail!.serviceDetail.checkListItems; let i = index"
        >
        <label class="d-flex align-items-end">
          <span>
            {{ i+1 }}.
          </span>
            <input
              class="k-checkbox cc-filter-checkbox ms-3"
              type="checkbox"
              kendoCheckBox
              [(ngModel)]="item.checked"
            />
            <span class="d-flex">
              <span *ngIf="!item.link" title="{{ item.checklistItem }}">
                {{ item.checklistItem }}
              </span>
              <span *ngIf="item.link" title="{{ item.checklistItem }}">
                <a href="{{ item.link }}" target="_blank">
                  {{ item.checklistItem }}
                </a>
              </span>
            </span>
          </label>
        </li>
      </ul>
    </div>
  </div>
  <kendo-dialog-actions class="cc-btn-panel">
    <button
      kendoButton
      class="btn btn-secondary"
      (click)="cancelCheckListDialog()"
      primary="true"
    >
      {{'_General_Button_Cancel_Text_' | translate }} 
    </button>
    <button
      kendoButton
      class="btn btn-primary"
      [disabled]="!getAllCheckListItemChecked()"
      (click)="completeCheckListDialog(checkListPopUpDetail!.serviceDetail.id)"
      primary="true"
    >
      {{'_Lobby_Wrap_Up_Complete_Button_Text_' | translate }} 
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog
  id="checkListForRequestedServiceDialogModel"
  title="Checklists"
  *ngIf="checkListPopUpDetailForRequestedService!.showRequestedServiceCheckList"
  (close)="cancelCheckListForRequestedServiceDialog()"
  [minWidth]="250"
  [width]="600"
>
  <kendo-dialog-messages closeTitle="{{'_General_Button_Close_Text_' | translate }}"></kendo-dialog-messages>
  <div class="psPanel px-2">
    <div class="ps-list">
      <ul *ngFor="let service of checkListPopUpDetailForRequestedService!.serviceDetails">
        <h3>{{service.name}}</h3>
        <li
          class="wrap-checklist-item checkbox ms-3"
          *ngFor="let item of service.checkListItems; let i = index"
        >
        <label>
          <span class="d-flex">
            <span>
              {{ i+1 }}.
            </span>
            <span *ngIf="!item.link" title="{{ item.checklistItem }}">
              {{ item.checklistItem }}
            </span>
            <span *ngIf="item.link" title="{{ item.checklistItem }}">
              <a href="{{ item.link }}" target="_blank">
                {{ item.checklistItem }}
              </a>
            </span>
          </span>
          </label>
        </li>
      </ul>
    </div>
  </div>
  <kendo-dialog-actions class="cc-btn-panel">
    <button
      kendoButton
      class="btn btn-secondary"
      (click)="cancelCheckListForRequestedServiceDialog()"
      primary="true"
    >
    {{'_General_Button_Close_Text_' | translate }} 
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
